"use client";

import { useCallback, memo } from "react";

import { useRovingFocus } from "../../hooks";
import { useNavbar } from "./navbar.context";
import { navbarLinkStyles } from "./styles/navbar-link.styles";

import type { NavbarLinkProps } from "./types/navbar-link.types";

export const NavbarLink: React.FC<NavbarLinkProps> = memo((props) => {
  const { children, className, onClick, ...rest } = props;

  const { toggleMenu } = useNavbar();

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      onClick?.(event);
      toggleMenu(null);
    },
    [onClick, toggleMenu],
  );

  const handlePointerEnter = useCallback(() => {
    toggleMenu(null);
  }, [toggleMenu]);

  const handleKeypress = useRovingFocus();

  return (
    <li role="presentation">
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions -- href is passed via ...rest */}
      <a
        className={navbarLinkStyles({ className })}
        onKeyDown={handleKeypress}
        onClick={handleClick}
        onPointerEnter={handlePointerEnter}
        {...rest}
      >
        {children}
      </a>
    </li>
  );
});

NavbarLink.displayName = "NavbarLink";
